import {
  DomainsPortfolioAction,
  LOAD_PURCHASED_DOMAINS,
  PURCHASED_DOMAINS_FAIL,
  PURCHASED_DOMAINS_SUCCESS, PurchasedDomainsFail, PurchasedDomainsSuccess,
  RESET_PURCHASED_DOMAINS,
} from "../actions";

export interface IDomainsPortfolioEntityState {
  purchased_domains: any[];
  loading: boolean;
  loaded: boolean;
}

export interface IDomainsPortfolioState {
  domains_portfolio: IDomainsPortfolioEntityState;
  loading: boolean;
  loaded: boolean;
}

export const initialState: IDomainsPortfolioState = {
  domains_portfolio: {} as IDomainsPortfolioEntityState,
  loading: false,
  loaded: false
};

export function reducer(state: IDomainsPortfolioState = initialState, action: DomainsPortfolioAction): IDomainsPortfolioState {
  let payload: any;
  switch (action.type) {
    case  LOAD_PURCHASED_DOMAINS:
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case PURCHASED_DOMAINS_SUCCESS:
      payload = (<PurchasedDomainsSuccess>action).payload;
      return {
        ...state,
        domains_portfolio: {purchased_domains: payload.domains, loading: false, loaded: true},
        loading: false,
        loaded: true
      };

    case  PURCHASED_DOMAINS_FAIL:
      payload = (<PurchasedDomainsFail>action);
      return {
        ...state,
        domains_portfolio: {purchased_domains: [], loading: false, loaded: true},
        loading: false,
        loaded: false
      };

    case RESET_PURCHASED_DOMAINS:
      return {
        ...initialState
      };
  }

  return state;
}
